// UI
import Breadcrumbs from '@/components/ui/Breadcrumbs'
import ComponentSelect2 from '@/components/ui/ComponentSelect2'
import LocationSelect from '@/components/ui/LocationSelect'

// React
import { useState, useEffect } from 'react'

// API
import { useAxiosApi } from '@/hooks/useAxiosApi'

// Mantine
import { NumberInput, Button, Anchor } from '@mantine/core'
import { DatePickerInput } from '@mantine/dates'

// Dayjs
import dayjs from 'dayjs'

// Next
import { useSearchParams, useNavigate } from 'react-router-dom'
import Box from '@/components/ui/Box'

export default function ProductionOrderCreate() {
    const [componentId, setComponentId] = useState(null)
    const [component, setComponent] = useState(null)
    const [locationId, setLocationId] = useState('1')

    const [quantity, setQuantity] = useState(null)

    const [dates, setDates] = useState([null, null])

    // On component select
    const onSelect = (component) => {
        setComponentId(component.id)
    }

    // Check if url has component_id and set it
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()

    useEffect(() => {
        if (searchParams.get('component_id')) {
            setComponentId(searchParams.get('component_id'))
        }
    }, [searchParams])

    // Load component
    const { requestGet, requestPost } = useAxiosApi()

    const loadComponent = async () => {
        const { data } = await requestGet(`/components/${componentId}/children`)

        setComponent(data)
    }

    useEffect(() => {
        if (componentId) {
            loadComponent()
        }
    }, [componentId])

    // Create production order

    const createProductionOrder = async () => {
        if (!isValid) return

        const { data } = await requestPost('/production-orders', {
            component_id: componentId,
            quantity,
            starting_at: dayjs(dates[0]).format('YYYY-MM-DD'),
            ending_at: dayjs(dates[1]).format('YYYY-MM-DD'),
            location_id: locationId,
        })

        navigate(`/assembly/${data.id}`)
    }

    const breadcrumbs = [
        {
            label: 'Assemblages',
            href: '/assembly',
        },
        {
            label: 'Créer un assemblage',
        },
    ]

    const isValid =
        component && quantity && dates[0] && dates[1] &&
        !dayjs(dates[1]).isBefore(dayjs(dates[0]), 'day')

    return (
        <div>
            <Breadcrumbs breadcrumbs={breadcrumbs} />

            <div className="p-5 max-w-[800px] mx-auto">
                <Box>
                    {!componentId && (
                        <ComponentSelect2
                            label="Choisir une tête de montre à assembler"
                            onSelect={onSelect}
                            filters="category:=watch_head"
                        />
                    )}

                    {component && (
                        <div className="flex flex-col gap-5">
                            <span className="text-center">
                                <Anchor
                                    size="lg"
                                    href={`/components/${component.id}`}
                                >
                                    Tête de montre – {component.name}
                                </Anchor>
                            </span>

                            <div className="grid grid-cols-1 gap-5">
                                <LocationSelect
                                    label="Lieu d'assemblage"
                                    value={locationId}
                                    onChange={setLocationId}
                                    onlyProductComponentsLocations={true}
                                />

                                <NumberInput
                                    label="Quantité à assembler"
                                    min={1}
                                    max={10000}
                                    value={quantity}
                                    onChange={setQuantity}
                                />

                                <DatePickerInput
                                    type="range"
                                    allowSingleDateInRange
                                    value={dates}
                                    onChange={setDates}
                                    label="Dates de l'assemblage"
                                    locale="fr"
                                    valueFormat="LL"
                                    labelSeparator="au"
                                />
                            </div>

                            <Button
                                onClick={createProductionOrder}
                                disabled={!isValid}
                            >
                                Créer l'assemblage
                            </Button>
                        </div>
                    )}
                </Box>
            </div>
        </div>
    )
}
